var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.857,
    height: 20,
    viewBox: "0 0 22.857 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_server",
    "data-name": "solid server",
    d: "M21.429,37.714h-20A1.429,1.429,0,0,1,0,36.286V33.429A1.429,1.429,0,0,1,1.429,32h20a1.429,1.429,0,0,1,1.429,1.429v2.857A1.429,1.429,0,0,1,21.429,37.714Zm-2.143-3.929a1.071,1.071,0,1,0,1.071,1.071A1.071,1.071,0,0,0,19.286,33.786Zm-2.857,0A1.071,1.071,0,1,0,17.5,34.857,1.071,1.071,0,0,0,16.429,33.786Zm5,11.071h-20A1.429,1.429,0,0,1,0,43.429V40.571a1.429,1.429,0,0,1,1.429-1.429h20a1.429,1.429,0,0,1,1.429,1.429v2.857A1.429,1.429,0,0,1,21.429,44.857Zm-2.143-3.929A1.071,1.071,0,1,0,20.357,42,1.071,1.071,0,0,0,19.286,40.929Zm-2.857,0A1.071,1.071,0,1,0,17.5,42,1.071,1.071,0,0,0,16.429,40.929Zm5,11.071h-20A1.429,1.429,0,0,1,0,50.571V47.714a1.429,1.429,0,0,1,1.429-1.429h20a1.429,1.429,0,0,1,1.429,1.429v2.857A1.429,1.429,0,0,1,21.429,52Zm-2.143-3.929a1.071,1.071,0,1,0,1.071,1.071A1.071,1.071,0,0,0,19.286,48.071Zm-2.857,0A1.071,1.071,0,1,0,17.5,49.143,1.071,1.071,0,0,0,16.429,48.071Z",
    transform: "translate(0 -32)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs-icon.241bc60f85d6c858bef820d44832bb55.svg";
export { ForwardRef as ReactComponent };